import { render, staticRenderFns } from "./doc_general.vue?vue&type=template&id=60f2f846&scoped=true&"
import script from "./doc_general.vue?vue&type=script&lang=js&"
export * from "./doc_general.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f2f846",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60f2f846')) {
      api.createRecord('60f2f846', component.options)
    } else {
      api.reload('60f2f846', component.options)
    }
    module.hot.accept("./doc_general.vue?vue&type=template&id=60f2f846&scoped=true&", function () {
      api.rerender('60f2f846', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_sb/doc/edit/tabs/doc_general.vue"
export default component.exports